export default {
	MAIN : "/",
	RESERVATION_ACTIONS: "/reservation",
	PAYMENT: "/payment",
	PAYMENT_FINISH: "/payment-finish",
	USER_MANUAL: "/user-manual",
	ACCESSIBILITY_DECLARATION: "/accessibility-declaration",
	TERMS: "/terms",
	PRIVACY_POLICY: "/privacy-policy",
	PAGE_404: "/404"
}